const React = require('react');
const Ripple = require('../../../../../Ripple');


module.exports = ({
  checked,
  ...props
}) => {
  return (
    <Ripple
      {...props}
      className={`layoutRow fhaC fvaC h45 wmin76 ph10 bs b1 bc0 f12 fw4 lh lts0em
        tdN olN bc0:not[.disabled]:not[.checked]:h r6 dn
        (bg|bc)A3A7AC.disabled.checked o50.disabled:not[.checked]
        (cF|(bg|bc)5B47FF|bg4B37EF:not[.disabled]:h!).checked `
        + (checked ? 'checked ' : '')
        + (props.className || '')
      }
    />
  );
};
